export default __webpack_public_path__ + "static/select-replay-control-flag-dark-mode-743f8e9f4c36061f723130837298d9d0.png";